// import axiosHelper from "axiosHelper";
import axiosHelper from "../../../../../axiosHelper";
import {
  APIUSEROLD,
  API_FAILURE,
  FETCH_QUESTION_LIST_REQUESTOR,
  GET_REVIEW_REQUEST_RESPONSE_APPROVER,
  GET_VENDOR_NEED_APPROVAL,
} from "../../../../../config/constants";
import { apiErrors } from "../../../../../helper";
import Toaster from "../../../../common/Toaster";
export function fetchQuestionList(Id, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getSelfAssesmentQuestionListFromRequestor}?Id=${Id}&RequestedBy=Requester`
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: FETCH_QUESTION_LIST_REQUESTOR,
            payload: {
              data: response.status === 204 ? [] : response?.data,
              Id, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } else {
          callback(error, null);
        }
        // Assuming apiErrors is a function to handle API errors
        // apiErrors(error);
      });
  };
}
export function fetchVendorNeedApprovalList(Id, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getVendorNeedApprovalService}?VendorRequirementRegistrationId=${Id}`
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_VENDOR_NEED_APPROVAL,
            payload: {
              data: response.status === 204 ? [] : response?.data,
              Id, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } else {

          callback(error, null);
        }
        // Assuming apiErrors is a function to handle API errors
        // apiErrors(error);
      });
  };
}

export function getAssiginAuditorListingServices() {
  const request = axiosHelper.get(`${APIUSEROLD.getAssignAuditorList}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}

export function saveSelfAssesment(data, callback = () => { }) {
  return (dispatch) => {
    // Dispatch API request action if needed
    // dispatch({ type: API_REQUEST });

    // Send the request to save self-assessment data
    const request = axiosHelper.post(APIUSEROLD.saveSelfAssesmentRequestor, data);
    request
      .then((response) => {
        // Check if the response is successful
        if (response.data && response.data.IsSuccessful) {
          // Call the callback function with the response
          callback(null, response.data);
        } else {
          // Call the callback function with the error message
          callback(response.data?.Message || "Unknown error occurred", null);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
        } else {

          // apiErrors(error)
          // Call the callback function with the error message
          callback(error.response || "Network error occurred", null);
          // Dispatch API failure action if needed
          // dispatch({ type: API_FAILURE });
        }
      });
  };
}

// export function saveAcceptRejectLevelApprover(data, callback = () => { }) {
//   return (dispatch) => {
//     //dispatch({ type: API_REQUEST });
//     const request = axiosHelper.post(APIUSEROLD.saveAcceptRejectLevelApprover, data);
//     request
//       .then((response) => {
//         if (response) {
//           callback(response);
//         }
//       })
//       .catch((error) => {
//         Toaster.error(error?.response?.data?.ErrorMessage);
//         dispatch({ type: API_FAILURE });
//       });
//   };
// }

export function saveAcceptRejectLevelApprover(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.saveAcceptRejectLevelApprover, data)
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
        } else {
          Toaster.error(error?.response?.data?.ErrorMessage);
          dispatch({ type: API_FAILURE })
          if (error.response.status === 401) {
            apiErrors(error)
          }else{

            callback(error);
          }
        }
      })
  }
}




export function initiateRequestForCorrection(data, callback = () => { }) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.initiateRequestForCorrectionService, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          if (error.response.status === 401) {
            apiErrors(error)
          }else{

            Toaster.error(error?.response?.data?.ErrorMessage);
            dispatch({ type: API_FAILURE });
          }
        }
      });
  };
}


export function getApplicationStepStatusBar(vendorRequirementRegistrationId) {
  return axiosHelper.get(`${APIUSEROLD.getStepBarStatusforAdmin}?vendorRequirementRegistrationId=${vendorRequirementRegistrationId}`)
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response data to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{

        console.error('API error:', error);
        throw error; // Re-throw the error to the caller
      }
      // Handle API errors here if needed
    });
}


export function fetchReviewRequestResponseforApprover(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getReviewRequestResponseforApprover}`, {
      params: {
        VendorRequirementRegistrationId: filter?.VendorRequirementRegistrationId,
      }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_REVIEW_REQUEST_RESPONSE_APPROVER,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}
export function responseApproverService(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.saveAcceptRejectLevelApprover, data)
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data)
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
        }else{

          Toaster.error(error?.response?.data?.ErrorMessage);
          dispatch({ type: API_FAILURE })
          if (error.response.status === 401) {
            apiErrors(error)
          }
          // apiErrors(error)
          // callback(error);
        }
      })
  }
}